export const ROUTES = {
  home: '/',
  auth: '/admin/login',
  /** Deep-linked from Cognito forgot-password email (`email` + `code` query params). */
  resetPassword: '/admin/reset-password',
  /** Help + legacy temp-password path; new invites deep-link to `resetPassword`. */
  acceptInvite: '/admin/accept-invite',
  /** Shelter workspace home — `AppShellLayout`, any signed-in shelter persona. */
  admin: '/admin',
  adminPets: '/admin/pets',
  adminSettings: '/admin/settings',
  adminSettingsAccount: '/admin/settings/account',
  adminSettingsSecurity: '/admin/settings/security',
  adminSettingsShelterInfo: '/admin/settings/shelter-info',
  adminSettingsSubscription: '/admin/settings/subscription',
  adminSettingsBilling: '/admin/settings/billing',
  adminSettingsCustomization: '/admin/settings/customization',
  adminSettingsQuiz: '/admin/settings/quiz',
  adminSettingsShelterCrm: '/admin/settings/shelter-crm',
  adminSettingsAttributeMapping: '/admin/settings/attribute-mapping',
  adminSettingsTerms: '/admin/settings/terms',
  adminAnalytics: '/admin/analytics',
  /** Super Admin tools — nested under `RequireSuperAdmin`. */
  adminUsers: '/admin/users',
  /** Shelter Admins: roster in own org — `RequireShelterAdministrator`. */
  adminShelterUsers: '/admin/shelter/users',
  /** Shelter Admins: subscription tier / lifecycle — `RequireShelterAdministrator`. */
  adminShelterSubscription: '/admin/shelter/subscription',
  /** Stripe Checkout return — poll until webhook activates subscription. */
  adminShelterSubscriptionCheckoutSuccess:
    '/admin/shelter/subscription/checkout/success',
  /** Shelter staff: Friendr analytics — `RequireShelterAnalyticsAccess`. */
  adminShelterAnalytics: '/admin/shelter/analytics',
  /** Shelter Admins: training (placeholder) — `RequireShelterAdministrator`. */
  adminShelterTraining: '/admin/shelter/training',
  adminShelters: '/admin/shelters',
  adminMatchQuestions: '/admin/match-questions',
  /** Super Admin only — subscription tiers (`RequireSuperAdmin`). */
  adminSubscriptions: '/admin/subscriptions',
  matchingPoc: '/matching/knn',
  /** Public read-only view of persisted match results (`matchResultsId` UUID). */
  matchResultsShareRoot: '/match',
  /** Public adoption quiz per shelter roster (path segment is shelter UUID). */
  adoptShelterQuizRoot: '/adopt',
} as const;

export function matchResultsSharePath(matchResultsId: string): string {
  return `${ROUTES.matchResultsShareRoot}/${encodeURIComponent(matchResultsId.trim())}`;
}

export function adoptShelterQuizPath(shelterKey: string): string {
  return `${ROUTES.adoptShelterQuizRoot}/${encodeURIComponent(shelterKey)}`;
}

export function readAdoptionQuizSlugFromSettings(
  settings: Record<string, unknown> | undefined | null,
): string | null {
  if (!settings || typeof settings !== 'object') return null;
  const adoptionQuiz = settings.adoptionQuiz;
  if (
    !adoptionQuiz ||
    typeof adoptionQuiz !== 'object' ||
    Array.isArray(adoptionQuiz)
  ) {
    return null;
  }
  const slug = (adoptionQuiz as Record<string, unknown>).slug;
  if (typeof slug !== 'string') return null;
  const trimmed = slug.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/** Prefer marketing slug when configured; otherwise use shelter UUID. */
export function adoptShelterQuizPathForShelter(
  shelterId: string,
  settings?: Record<string, unknown> | null,
): string {
  const slug = readAdoptionQuizSlugFromSettings(settings);
  return adoptShelterQuizPath(slug ?? shelterId);
}
